import React, { useState, useEffect, Fragment } from "react"
import { Button, DialogTitle, DialogContent, TextField, DialogActions, Grid, FormControl, FormLabel, FormControlLabel, Radio, Dialog, Tooltip } from "@material-ui/core"
import RadioGroup from "@material-ui/core/RadioGroup"
import CloseIcon from "@material-ui/icons/Close"
import GetAppIcon from '@material-ui/icons/GetApp';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LinkIcon from '@material-ui/icons/Link';
import { formValues } from "../containers/OccmTaskFormData"
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { backendDateFormat, dayMonthDateFormat, fieldDMYShort } from "../../../../constants";
import { addOccmFormApi, deleteAdAttachment } from "../apiService";
import { DeletePopUp } from "../../../../shared_elements";
import { regexConstants } from "../../../../constants/regEx";
import { checkApiStatus } from "../../../../utils";
import { trackActivity } from '../../../../utils/mixpanel';
import { globalPutService } from "../../../../utils/globalApiServices"
import LinkFiles from "../../../../shared_elements/components/LinkFiles"
import UploadFile from "../../../../shared_elements/components/UploadFile"
import { assetType, imgStoragePath } from "../../../../constants";
import config from "../../../../config";
import { acumenCamo } from "../../../../shared_elements/components";

const OccmTaskForm = (props) => {
	const {
		formTitle, closeAddForm, editFormId, editFormData,
		attachments: propAttachments, updateFormData, fileUploadData,
		uuid, last_used_folder_uuid, last_used_folder_uuid_link_document,
		checkbox_last_used_folder_uuid, checkbox_last_used_folder_name,
		getResponseBack, actionType
	} = props;

	const [error, setError] = useState({});
	const [data, setData] = useState(formValues);
	const [attachments, setAttachments] = useState([]);
	const [newUploadedAttachments, setNewUploadedAttachments] = useState([]);
	const [open, setOpen] = useState(false);
	const [deleteAttachmentId, setDeleteAttachmentId] = useState(0);
	const [linkFile, setLinkFile] = useState(false);
	const [uploadFile, setUploadFile] = useState(false);

	useEffect(() => {
		if (editFormId) fillEditData();
		trackActivity('CAMO', {
			event_type: 'Modal Opened',
			page_title: 'OC-CM Add Task Form',
		});
	}, []);

	const fillEditData = () => {
		setAttachments(propAttachments || []);
		setData(editFormId ? editFormData : {});
	};

	const onFieldChange = (keyParam, value) => {
		setData(prev => ({ ...prev, [keyParam]: value }));
	};

	const onRestErrorKey = (keyParam) => {
		setError(prev => ({ ...prev, [keyParam]: "" }));
	};

	const buildValidationInputs = (formData) => ({
		ata_chapter: (acumenCamo || formData?.ata_chapter?.trim()) ? '' : "Please enter ATA chapter",
		part_number: formData?.part_number?.trim() ? '' : "Please enter part number",
		part_serial_number: (acumenCamo || formData?.part_serial_number?.trim()) ? '' : "Please enter part serial number",
		part_installation_date: (acumenCamo || formData?.part_installation_date) ? '' : "Please select part installation date",
		position: (acumenCamo || formData?.position?.trim()) ? '' : "Please enter position",
		faa_easa_certificate: (acumenCamo || formData?.faa_easa_certificate) ? '' : "Please enter faa easa certificate",
		part_description: (acumenCamo || formData?.part_description?.trim()) ? '' : "Please enter part description",
	});

	const onFocusValidation = () => {
		const validationInputs = buildValidationInputs(data);
		if (!Object.values(validationInputs).every(v => v === "")) {
			setError(validationInputs);
		}
	};

	const handleSubmit = async (e, currentBtnStatus) => {
		e.preventDefault();
		const validationInputs = buildValidationInputs(data);
		if (Object.values(validationInputs).every(v => v === "")) {
			const occmProps = props.props;
			const isUpdate = currentBtnStatus === "update";
			let payload = Object.assign({}, data)
			payload = {
				...payload,
				part_csn: data?.part_csn || null,
				part_tsn: data?.part_tsn || null,
				aircraft_tsn: data?.aircraft_tsn || null,
				aircraft_csn: data?.aircraft_csn || null,
				asset_id: occmProps.match.params.asset,
				asset_type_id: occmProps.match.params.assetType,
			};
			if (isUpdate) {
				if (editFormId) {
					await uploadFileTest(editFormId, occmProps, true, "update");
				}
				await updateFormData(editFormId, data, occmProps);
				closeAddForm();
				trackActivity('CAMO', {
					event_type: 'Task Updated Successfully',
					page_title: 'OC-CM',
					item_id: editFormId || '',
					request_body: payload || ''
				});
			} else {
				addOccmFormApi(payload, occmProps).then(async (response) => {
					const uploadId = response?.data?.data?.id;
					if (uploadId) {
						await uploadFileTest(uploadId, occmProps, false, currentBtnStatus);
						trackActivity('CAMO', {
							event_type: 'Task Added Successfully',
							page_title: 'OC-CM',
							item_id: uploadId || '',
							request_body: payload || '',
							response_msg: response.data.message || ''
						});
					}
				});
				if (currentBtnStatus !== "addAnother") {
					closeAddForm();
				}
			}
		} else {
			setError(validationInputs);
			trackActivity('CAMO', {
				event_type: `${currentBtnStatus === "update" ? "Update" : "Add"} TASK Failed`,
				page_title: 'OC-CM',
				error_source: 'Frontend',
				error_type: validationInputs || ''
			});
		}
	};

	const addFormData = (e) => handleSubmit(e, "add");
	const saveAndAddAnother = (e) => handleSubmit(e, "addAnother");
	const updateData = (e) => handleSubmit(e, "update");

	const uploadFileTest = async (uploadId, occmProps, isUpdate, currentBtnStatus) => {
		if (newUploadedAttachments.length > 0) {
			const formdata = new FormData();
			const module_type_id = 3;
			Object.keys(newUploadedAttachments).forEach((key) => {
				formdata.append(`[${key}]file`, newUploadedAttachments[key]);
				formdata.append(`[${key}]file_type`, newUploadedAttachments[key].type);
				formdata.append(`[${key}]file_name`, newUploadedAttachments[key].name);
				formdata.append(`[${key}]module_id`, uploadId);
				formdata.append(`[${key}]module_type_id`, module_type_id);
				formdata.append(`[${key}]asset_id`, occmProps.match.params.asset);
				formdata.append(`[${key}]asset_type_id`, occmProps.match.params.assetType);
			});
			fileUploadData(uploadId, formdata, occmProps, true);
			if (currentBtnStatus === "addAnother") {
				resetBothAttachmentArray();
			}
			if (!isUpdate) {
				onSubmitFileLink(uploadId);
				fileUploadData(uploadId, null, occmProps, false);
			}
		} else {
			if (currentBtnStatus === "addAnother") {
				setData(formValues);
				setAttachments([]);
				setNewUploadedAttachments([]);
				setOpen(false);
				setDeleteAttachmentId(0);
				document.getElementById("asset-form").reset();
				fileUploadData(uploadId, null, occmProps, false);
			} else if (!isUpdate) {
				onSubmitFileLink(uploadId);
				fileUploadData(uploadId, null, occmProps, false);
			}
		}
	};

	const resetBothAttachmentArray = () => {
		setData(formValues);
		setAttachments([]);
		setNewUploadedAttachments([]);
		setOpen(false);
		setDeleteAttachmentId(0);
		document.getElementById("asset-form").reset();
	};

	const onUpload = (files) => {
		const chosenFiles = Array.prototype.slice.call(files);
		for (let i = 0; i < chosenFiles.length; i++) {
			if (chosenFiles[i].size > 52428800) {
				props.props.enqueueSnackbar(
					`${chosenFiles[i].name} Maximum file size should be 50MB.`,
					{ variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }
				);
				delete chosenFiles[i];
			} else {
				handleUploadFiles(chosenFiles);
			}
		}
	};

	const handleUploadFiles = (files) => {
		const uploaded = [...newUploadedAttachments];
		const existingAttachments = [...attachments];
		files.forEach((file) => {
			uploaded.push(file);
			existingAttachments.push({
				id: 0,
				module_id: 0,
				module_type_id: 3,
				file_name: file.name,
				file_type: file.type,
				file: "",
				name: file.name,
				asset_id: props.props.match.params.asset,
				asset_type_id: props.props.match.params.assetType
			});
		});
		setNewUploadedAttachments(uploaded);
		setAttachments(existingAttachments);
	};

	const handleCloseAttachment = () => {
		setOpen(false);
		setDeleteAttachmentId(0);
	};

	const deleteAttachmentFile = async (id, file) => {
		if (id !== undefined && id !== 0) {
			deleteAdAttachment(id, props.props);
			setAttachments(prev => prev.filter(att => att.id !== id));
			setOpen(false);
			setDeleteAttachmentId(0);
		} else {
			onRemoveCamoFile(file);
		}
	};

	const getResponseBackFn = (file) => {
		setData(prev => ({ ...prev, checklist: file }));
	};

	const listResponseBack = (file) => {
		if (actionType !== "add") {
			getResponseBack(file);
		}
	};

	const onUnlinkCheckListFile = (checklist, fileId) => {
		let payload = {};
		payload.delete = true;
		payload.folder_ids = checklist?.folders?.filter(items => items.type === 'folder').map(file => file.id).filter(id => id !== fileId).join(',');
		payload.file_ids = checklist?.files?.filter(items => items.type === 'file').map(file => file.id).filter(id => id !== fileId).join(',');
		globalPutService(`camo/occm/${editFormId}/document-checklists/`, payload)
			.then((response) => {
				if (checkApiStatus(response)) {
					const updatedChecklist = { ...checklist };
					updatedChecklist.files = updatedChecklist.files.filter(file => file.id !== fileId);
					updatedChecklist.folders = updatedChecklist?.folders.filter(file => file.id !== fileId);
					setData(prev => ({ ...prev, checklist: updatedChecklist }));
				}
				trackActivity('CAMO', {
					event_type: 'Checklist File Unlinked',
					page_title: 'OC-CM',
					file_id: fileId || '',
					edited_form_id: editFormId || '',
					request_body: payload || ''
				});
			});
	};

	const onRemoveFile = (file) => {
		setData(prev => ({ ...prev, checklist: prev.checklist.filter(item => item.name !== file.name) }));
	};

	const onRemoveCamoFile = (file) => {
		setAttachments(prev => prev.filter(item => item.file_name !== file.file_name));
	};

	const onLinkFile = (file, linkUuid, type) => {
		if (type === "link" || linkUuid) {
			const folderUUID = [...(data.folder_uuid || []), linkUuid];
			const updatedChecklist = [...(data.checklist || []), file];
			setData(prev => ({
				...prev,
				checklist: updatedChecklist.flat(),
				folder_uuid: folderUUID.flat(),
			}));
		} else {
			onUpload(file);
		}
	};

	const onSubmitFileLink = (id) => {
		if (data?.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
			let payload = {};
			if (data.checklist.some(item => item.type === 'folder') && data.checklist.some(item => item.type === 'file')) {
				payload.folder_ids = data.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
				payload.file_ids = data.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
			} else if (data.checklist.some(item => item.type === 'folder')) {
				payload.folder_ids = data.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
			} else {
				payload.file_ids = data.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
			}
			globalPutService(`camo/occm/${id}/document-checklists/`, payload).then(response => {
				if (checkApiStatus(response)) {
					getResponseBack();
				} else {
					props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
				}
			});
		}
		if (data?.folder_uuid?.length > 0 && data.folder_uuid.filter(item => item !== undefined)) {
			const formData = new FormData();
			formData.append('folder_uuid', data.folder_uuid.filter(item => item !== undefined));
			data.checklist.filter(item => item instanceof File).forEach((file) => {
				formData.append('files[]', file);
			});
			globalPutService(`camo/occm/${id}/document-checklists/`, formData).then(response => {
				if (checkApiStatus(response)) {
					getResponseBack();
				} else {
					props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
				}
			});
		}
	};

	return (
		<Fragment>
			<div id="AmpTaskForm">
				<div id="HtTaskForm">
					<DialogTitle>
						{formTitle}
						<CloseIcon
							onClick={() => { closeAddForm(); listResponseBack(); }}
							className="close-icon"
						/>
					</DialogTitle>
					<DialogContent>
						<Grid spacing={1} container>
							<Grid item md={3} sm={6} xs={12}>
								<TextField
									required={acumenCamo ? false : true}
									variant="outlined"
									label="ATA Chapter"
									name="ata_chapter"
									id="ata_chapter"
									value={data?.ata_chapter || ''}
									error={acumenCamo ? false : !!error.ata_chapter}
									helperText={acumenCamo ? '' : error.ata_chapter || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 15 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("ata_chapter", input);
											onRestErrorKey("ata_chapter");
										} else if (input.length > 15 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("ata_chapter", input.slice(0, 15));
											onRestErrorKey("ata_chapter");
										} else {
											e.preventDefault();
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("ata_chapter")}
								/>
							</Grid>

							<Grid item md={3} sm={6} xs={12}>
								<TextField
									required
									variant="outlined"
									label="Part Number"
									name="part_number"
									id="part_number"
									value={data.part_number}
									error={!!error.part_number}
									helperText={error.part_number || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 20) {
											onFieldChange("part_number", input);
											onRestErrorKey("part_number");
										} else {
											onFieldChange("part_number", input.slice(0, 20));
											onRestErrorKey("part_number");
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("part_number")}
								/>
							</Grid>
							<Grid item md={3} sm={6} xs={12}>
								<TextField
									required={acumenCamo ? false : true}
									variant="outlined"
									label="Part Serial Number"
									name="part_serial_number"
									id="part_serial_number"
									value={data.part_serial_number}
									error={acumenCamo ? false : !!error.part_serial_number}
									helperText={acumenCamo ? "" : error.part_serial_number || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 20) {
											onFieldChange("part_serial_number", input);
											onRestErrorKey("part_serial_number");
										} else {
											onFieldChange("part_serial_number", input.slice(0, 20));
											onRestErrorKey("part_serial_number");
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("part_serial_number")}
								/>
							</Grid>
							<Grid item md={3} sm={6} xs={12} className="input-calender">
								<MuiPickersUtilsProvider utils={MomentUtils}>
									<KeyboardDatePicker
										id="part_installation_date"
										required={acumenCamo ? false : true}
										label="Part Installation Date "
										format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
										inputVariant="outlined"
										fullWidth
										disableFuture
										InputLabelProps={{ shrink: true }}
										minDate={moment().subtract(25, "years")}
										value={data.part_installation_date}
										error={!!error.part_installation_date}
										helperText={error.part_installation_date || ""}
										onFocus={() => onRestErrorKey("part_installation_date")}
										onChange={(date) => {
											onFieldChange("part_installation_date", moment(date).format(backendDateFormat));
											onRestErrorKey("part_installation_date");
										}}
										onFocusCapture={() => onFocusValidation("part_installation_date")}
									/>
								</MuiPickersUtilsProvider>
							</Grid>
							<Grid item md={12} sm={12} xs={12}>
								<TextField
									required={acumenCamo ? false : true}
									variant="outlined"
									label="Part Description"
									name="part_description"
									id="part_description"
									multiline
									rows={2}
									value={data.part_description}
									error={acumenCamo ? false : !!error.part_description}
									helperText={acumenCamo ? "" : error.part_description || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 255) {
											onFieldChange("part_description", input);
											onRestErrorKey("part_description");
										} else {
											onFieldChange("part_description", input.slice(0, 255));
											onRestErrorKey("part_description");
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("part_description")}
								/>
							</Grid>
							<Grid item md={2} sm={6} xs={12}>
								<TextField
									variant="outlined"
									label={
										<React.Fragment>
											{props.props.match.params.assetType == 1 ? "Aircraft TSN Installation" : "Engine TSN Installation"}
										</React.Fragment>
									}
									name="aircraft_tsn"
									id="aircraft_tsn"
									value={data.aircraft_tsn}
									error={!!error.aircraft_tsn}
									helperText={error.aircraft_tsn || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("aircraft_tsn", input);
											onRestErrorKey("aircraft_tsn");
										} else if (input.length > 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("aircraft_tsn", input.slice(0, 10));
											onRestErrorKey("aircraft_tsn");
										} else {
											e.preventDefault();
										}
									}}
									onFocus={() => onRestErrorKey("aircraft_tsn")}
									InputLabelProps={{ shrink: true }}
								/>
							</Grid>
							<Grid item md={2} sm={6} xs={12}>
								<TextField
									variant="outlined"
									label={
										<React.Fragment>
											{props.props.match.params.assetType == 1 ? "Aircraft CSN Installation" : "Engine CSN Installation"}
										</React.Fragment>
									}
									name="aircraft_csn"
									id="aircraft_csn"
									value={data.aircraft_csn}
									error={!!error.aircraft_csn}
									helperText={error.aircraft_csn || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("aircraft_csn", input);
											onRestErrorKey("aircraft_csn");
										} else if (input.length > 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("aircraft_csn", input.slice(0, 10));
											onRestErrorKey("aircraft_csn");
										} else {
											e.preventDefault();
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("aircraft_csn")}
								/>
							</Grid>
							<Grid item md={2} sm={6} xs={12}>
								<TextField
									variant="outlined"
									label="Part TSN Installation"
									name="part_tsn"
									id="part_tsn"
									value={data.part_tsn}
									error={!!error.part_tsn}
									helperText={error.part_tsn || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("part_tsn", input);
											onRestErrorKey("part_tsn");
										} else if (input.length > 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("part_tsn", input.slice(0, 10));
											onRestErrorKey("part_tsn");
										} else {
											e.preventDefault();
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("part_tsn")}
								/>
							</Grid>

							<Grid item md={2} sm={6} xs={12}>
								<TextField
									variant="outlined"
									label="Part CSN Installation"
									name="part_csn"
									id="part_csn"
									value={data.part_csn}
									error={!!error.part_csn}
									helperText={error.part_csn || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("part_csn", input);
											onRestErrorKey("part_csn");
										} else if (input.length > 10 && regexConstants.onlyNumeric.test(input)) {
											onFieldChange("part_csn", input.slice(0, 10));
											onRestErrorKey("part_csn");
										} else {
											e.preventDefault();
										}
									}}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("part_csn")}
								/>
							</Grid>
							<Grid item md={4} sm={6} xs={12}>
								<TextField
									required={acumenCamo ? false : true}
									variant="outlined"
									label="Position"
									name="position"
									id="position"
									value={data?.position || ''}
									error={acumenCamo ? false : !!error.position}
									helperText={acumenCamo ? "" : error.position || ""}
									onChange={(e) => {
										const input = e.target.value;
										if (input.length <= 20) {
											onFieldChange("position", input);
											onRestErrorKey("position");
										} else {
											onFieldChange("position", input.slice(0, 20));
											onRestErrorKey("position");
										}
									}}
									onFocus={() => onRestErrorKey("position")}
									InputLabelProps={{ shrink: true }}
								/>
							</Grid>
						</Grid>
						<div className="border-grey"></div>
						<Grid id="data-container" spacing={1} container>
							<Grid item md={2} sm={6} xs={12}>
								<label>
									FAA / EASA Certificate
									{acumenCamo ? null : <span style={{ color: "red" }}> *</span>}
								</label>
								<FormControl
									error={!!error.faa_easa_certificate}
									helperText={error.faa_easa_certificate || ""}
									onFocus={() => onRestErrorKey("faa_easa_certificate")}
								>
									<RadioGroup
										required
										row
										aria-label="faa_easa_certificate"
										name="faa_easa_certificate"
										defaultValue="top"
										value={data.faa_easa_certificate}
										onChange={(e) => onFieldChange("faa_easa_certificate", e.target.value)}
										onBlur={() => onFocusValidation("faa_easa_certificate")}
									>
										<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
										<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
									</RadioGroup>
									{error.faa_easa_certificate && (
										<FormLabel component="faa_easa_certificate">
											<span style={{ color: "red" }}>{error.faa_easa_certificate}</span>
										</FormLabel>
									)}
								</FormControl>
							</Grid>

							<Grid item md={2} sm={6} xs={12}>
								<label>Shop Report</label>
								<FormControl component="fieldset">
									<FormLabel component="legend"></FormLabel>
									<RadioGroup
										row
										aria-label="shop_report"
										name="shop_report"
										defaultValue="top"
										value={data.shop_report}
										onChange={(e) => onFieldChange("shop_report", e.target.value)}
									>
										<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
										<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
									</RadioGroup>
								</FormControl>
							</Grid>
							<Grid item md={3} sm={6} xs={12}>
								<label>Certificate of Conformity</label>
								<FormControl component="fieldset">
									<FormLabel component="legend"></FormLabel>
									<RadioGroup
										row
										aria-label="conformity_certificate"
										name="conformity_certificate"
										defaultValue="top"
										value={data.conformity_certificate}
										onChange={(e) => onFieldChange("conformity_certificate", e.target.value)}
									>
										<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
										<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
										<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
									</RadioGroup>
								</FormControl>
							</Grid>
							<Grid item md={2} sm={6} xs={12}>
								<label>Goods receipt note</label>
								<FormControl component="fieldset">
									<FormLabel component="legend"></FormLabel>
									<RadioGroup
										row
										aria-label="receipt_note"
										name="receipt_note"
										defaultValue="top"
										value={data.receipt_note}
										onChange={(e) => onFieldChange("receipt_note", e.target.value)}
									>
										<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
										<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
									</RadioGroup>
								</FormControl>
							</Grid>
							<Grid item md={3} sm={6} xs={12}>
								<label>Installation Work order</label>
								<FormControl component="fieldset">
									<FormLabel component="legend"></FormLabel>
									<RadioGroup
										row
										aria-label="work_order"
										name="work_order"
										defaultValue="top"
										value={data.work_order}
										onChange={(e) => onFieldChange("work_order", e.target.value)}
									>
										<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
										<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
										<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
									</RadioGroup>
								</FormControl>
							</Grid>
						</Grid>
						<Grid spacing={1} container>
							<Grid item md={6} sm={12} xs={12}>
								<TextField
									label="Remarks"
									margin='normal'
									variant='outlined'
									fullWidth
									value={data.remark}
									InputLabelProps={{ shrink: true }}
									onChange={(e) => onFieldChange("remark", e.target.value)}
									rows={3}
									multiline
									inputProps={{ maxLength: 250 }}
								/>
							</Grid>
							<Grid item md={6} sm={12} xs={12}>
								<div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
									<ul className="list-inline spacing-list">
										<li className="list-inline-item" onClick={() => setUploadFile(true)}>
											<span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
										</li>
										<li className="list-inline-item" onClick={() => setLinkFile(true)}>
											<span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
										</li>
									</ul>
								</div>
							</Grid>
						</Grid>
						<Grid id="data-container" spacing={1} container>
							<Grid spacing={1} container>
								{actionType === 'add' ?
									<div className='checklist-files'>
										<ul className='list-inline'>
											{data?.checklist?.map((file) =>
												<li className='list-inline-item' key={file.name}>
													<span className='file-name'>{file.name}</span>
													<span className='file-remove'>
														<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => onRemoveFile(file)} color='secondary' fontSize='small' />
													</span>
												</li>
											)}
											{attachments?.map((attachment) =>
												<li className='list-inline-item' key={attachment.file_name}>
													<span className='file-name'>{attachment.file_name}</span>
													<span className='file-remove'>
														<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => onRemoveCamoFile(attachment)} color='secondary' fontSize='small' />
													</span>
												</li>
											)}
										</ul>
									</div>
									:
									<div className='checklist-files'>
										<ul className='list-inline'>
											{data?.checklist?.files?.map((file) =>
												<li className='list-inline-item' key={file.name}>
													<span className='file-name'>{file.name}</span>
													<span className='file-remove'>
														<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
													</span>
												</li>
											)}
											{data.checklist?.folders?.length > 0 && data.checklist.folders.map((file) => (
												<li className='list-inline-item' key={file.id}>
													<Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
														<a href={`${config.domain.records}${assetType[props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new">
															<img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Records Data Room" />
														</a>
													</Tooltip>
													<span className='file-name'>{file.name}</span>
													<span className='file-remove'>
														<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
													</span>
												</li>
											))}
											{attachments?.map((attachment) =>
												<li className='list-inline-item' key={attachment.file_name}>
													<span className='file-name'>{attachment.file_name}</span>
													<span className='file-remove'>
														<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => deleteAttachmentFile(attachment.id, attachment)} color='secondary' fontSize='small' />
													</span>
												</li>
											)}
										</ul>
									</div>
								}
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions className="actions-btn">
						<Button
							type="button"
							className="btn btn-primary"
							onClick={actionType === "add" ? addFormData : updateData}
						>
							{actionType === "add" ? "Add" : "Update"}
						</Button>
						{actionType === "add" && (
							<Button onClick={saveAndAddAnother} type="button" className="btn btn-primary">
								Save & Add Another
							</Button>
						)}
						<Button
							type="button"
							className="btn btn-primary"
							onClick={() => { closeAddForm(); listResponseBack(); }}
						>
							Close
						</Button>
					</DialogActions>
					{open ? (
						<DeletePopUp
							title="Delete Attachment"
							deleteRecordFn={() => deleteAttachmentFile(deleteAttachmentId)}
							modal={true}
							content="Do you really want to delete the selected Attachment?"
							toggleModalFn={handleCloseAttachment}
							confirmText="Confirm"
							cancelText="Cancel"
						/>
					) : null}
					<Dialog open={linkFile} onClose={() => setLinkFile(false)} id="htDialog">
						<LinkFiles
							handleClose={() => setLinkFile(false)}
							uuid={uuid?.uuid}
							editFormId={editFormId}
							getResponseBack={(file) => getResponseBackFn(file)}
							listResponseBack={(file) => listResponseBack(file)}
							actionType={actionType}
							onLinkFile={(file, any, type) => onLinkFile(file, any, type)}
							modType="occm"
							last_used_folder_uuid={last_used_folder_uuid_link_document}
							uploadFileInfo={data}
							attachments={attachments}
							type="link"
						/>
					</Dialog>
					<Dialog open={uploadFile} onClose={() => setUploadFile(false)} id="htDialog">
						<UploadFile
							handleClose={() => setUploadFile(false)}
							uuid={uuid?.uuid}
							editFormId={editFormId}
							getResponseBack={(file) => getResponseBackFn(file)}
							listResponseBack={(file) => listResponseBack(file)}
							actionType={actionType}
							onLinkFile={(file, linkUuid) => onLinkFile(file, linkUuid)}
							modType="occm"
							uploadFileInfo={data}
							last_used_folder_uuid={last_used_folder_uuid}
							onUpload={(file) => onUpload(file)}
							type="upload"
							checkbox_last_used_folder_uuid={checkbox_last_used_folder_uuid}
							checkbox_last_used_folder_name={checkbox_last_used_folder_name}
						/>
					</Dialog>
				</div>
			</div>
		</Fragment>
	)
}

export default OccmTaskForm